import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import { css, styled } from "styled-components";
import { theme } from "../styles/theme";
import { useEffect, useState } from "react";
import CircularProgress from "./CircularProgress";
import { formatTime } from "../shared/utils/helper";
import { FiMicOff } from "react-icons/fi";

interface RecorderProps{
    size?: number;
    countDown: number;
    videoRef: React.RefObject<HTMLVideoElement>;
    timer: number;
    duration: number;
    message: string;
    startPlayingQstn?: boolean;
    recordInitiated?: boolean;
    startRecording?: boolean;
}


export const CenteredText = styled.div`
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.extra};
    line-height: 130%;
    letter-spacing: 0%;
    text-align: center;
    color: #FFFFFF;
    z-index: 9999999999999999999999;
`;

const CircularContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// export const VideoContainer = styled.video`
//   width: 440px;
//   height: 440px;
//   position: relative;
//   border-radius: 50%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   aspect-ratio: 1 / 1;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//   background: red;
// `;

const VideoContainer = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures video fills container while maintaining aspect ratio */
  border-radius: 50%; /* Makes the video circular */
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  opacity: 1;
  z-index: 9999999999;
  transform: scaleX(-1);
`;


const Overlay = styled.div<{ visible?: boolean }>`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999999999999999;
    border-radius: 50%;

    background: rgba(0,0,0,0.5);
    ${props=>props.visible && css`
        background: rgba(0,0,0,0);
    `};
`

const RespondentContainer = styled.div<{size?: number}>`
 // width: ${props=>props.size || 440}px;
  //height: ${props=>props.size || 440}px;
  width:100%;
  height:100%;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 40px;
`;

const RespondentCount = styled.div`
//   position: relative;
  top: 20px;
  font-size: 14px;
  opacity: 0.7;
`;

const RecordText = styled.div`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
  @media (max-width: ${theme.breakpoints.mobileBig}px) {
    font-size: 15px;
    }
`;

const RecordSubtext = styled.div`
  font-size: 14px;
  opacity: 0.7;
  text-align: center;
  max-width: 200px;
  @media (max-width: ${theme.breakpoints.mobileBig}px) {
    font-size: 10px;
    }
`;

const TimerCounter = styled.div`
    height: 30px;
    position: absolute;
    background: #0000004D;

    top: 30px;
    left: 50%;
    transform: translate(-50%, -50%);
    gap: 4px;
    border-radius: 28px;
    padding-top: 8px;
    padding-right: 10px;
    padding-bottom: 8px;
    padding-left: 10px;

    


    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.sm};
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
`;

const Microphone = styled(FiMicOff)`
    width: 100px;
    height: 100px;
    color: #FFF;
    transition: opacity 0.5s ease-in-out;
    opacity: 0.3;  

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999999999999999;
`;

const Recorder: React.FC<RecorderProps>=({
    size,
    videoRef, 
    countDown, 
    timer, 
    duration, 
    startPlayingQstn = false,
    recordInitiated=false, 
    message,
    startRecording=false
})=>{
    const [countDownTimer, setCountDownTimer] = useState<string>("");
    const [inTimer, setInTimer] = useState<number>(0);
    const [start, setStart] = useState<boolean>(false);
    const [muted, setMuted] = useState<boolean>(true);

    useEffect(() => {
        //setInTimer(timer);
      
        if (timer > 0) {
          const timeRemaining = duration - Math.floor(timer);
          const formatted = formatTime(timeRemaining || 0);
          setCountDownTimer(`${formatted} left`);
        } else {
            //   setCountDownTimer("Time's up");
            const formatted = formatTime(duration || 0);
            setCountDownTimer(`${formatted} left`);
        }
      }, [timer, duration]);
      
    

    useEffect(()=>{
        setStart(recordInitiated);
    }, [recordInitiated]);

   
    return(
        <>
            <CircularProgress
                size={size || 440}
                strokeWidth={startRecording? 7 : 0}
                duration={duration}
                progress={(timer / duration) * 100}
                progressColor="#8451D6"
                trailColor="#ddd"
                startAngle={51}
                onFinish={() => alert("Progress Completed!")}
            >
                <VideoContainer
                    ref={videoRef}
                    muted
                    playsInline
                    style={{
                        boxShadow:'2px 2px 4px rgba(0, 0, 0, 0.1)',
                    }}
                />   
            </CircularProgress>
            
            {!startRecording && !recordInitiated && (
                <Overlay>
                    <RespondentContainer size={size}>
                      {/*   <RespondentCount>{message}</RespondentCount>
                        <RecordText>Record Response</RecordText> */}
                        <RecordSubtext>Frame yourself then press Record to begin your Qcast Interview recording</RecordSubtext>
                    </RespondentContainer>
                </Overlay>    
            )}
            {/* {!startPlayingQstn && startRecording && recordInitiated && countDown > 0 && (
                <Overlay><CenteredText> {countDown} </CenteredText></Overlay>
            )} */}
            {(startRecording && recordInitiated && countDownTimer !== "") && <Overlay visible={true}><TimerCounter>{countDownTimer}</TimerCounter></Overlay>}
            {(!startRecording && recordInitiated) && <Overlay visible={true}><CenteredText><Microphone /></CenteredText></Overlay>}
        </>
    )
}

export default Recorder;

